export default "/fonts/iconly.woff?ece11b87e544d408ac32dc9e1173d66b";